
import { Quest, QuestCategory } from '../../../types';

export const CHEFS_JOURNEY_QUESTS: Quest[] = [
  { 
    id: 702, 
    category: QuestCategory.SkillBuilder, 
    title: 'Breakfast Boss',
    questlineId: 'chefs-journey',
    isQuestlineStart: true,
    description: 'Your journey to becoming a Master Chef starts with the first meal of the day. Learn to make your own breakfast.',
    details: "Learn to be the boss of your own breakfast! Ask an adult to show you how to prepare your own cereal, toast, or yogurt and fruit. Learning where everything is and how to clean up is the first step to kitchen independence.",
    repeatDescription: 'Take charge and make your own breakfast this morning.',
    repeatDetails: "You're the Breakfast Boss! Your mission is to make your own breakfast. Remember to be clean and tidy, wiping up spills and putting everything away. Enjoy the meal you made yourself!",
    youtubeId: "xXU-rK5G25Y"
  },
  { 
    id: 18, 
    category: QuestCategory.SkillBuilder, 
    title: 'The Lunch Pro', 
    questlineId: 'chefs-journey',
    prerequisiteQuestId: 702,
    description: 'You\'ve mastered breakfast. It\'s time to level up your chef skills by making your own lunch.',
    details: "Time to build on your skills. Ask an adult to teach you how to safely make a more complex lunch, like a sandwich, wrap, or a tasty salad. Pay attention to safety and cleanliness—you are learning the marks of a true pro.",
    repeatDescription: "You've got this! Time to make your own awesome lunch.",
    repeatDetails: "You're a Lunch Pro now. Time to practice your craft. Remember the key steps: get your ingredients, prepare your food safely, and most importantly, clean up your station when you're done. What awesome creation will you make today?"
  },
  {
    id: 940,
    category: QuestCategory.SkillBuilder,
    title: 'Sous-Chef in Training',
    questlineId: 'chefs-journey',
    prerequisiteQuestId: 18,
    description: 'You\'re confident with solo meals. The next level is to help an adult make dinner as a team.',
    details: "You are now a trusted chef. Your mission is to be a 'sous-chef' (French for 'under-chef') and help make a complex meal. Ask what you can do to help: wash vegetables, measure ingredients, or set the table. You are learning how a real kitchen team works!",
    repeatDescription: 'Report for duty! Help out as a sous-chef for tonight\'s dinner.',
    repeatDetails: 'The head chef needs you! Ask how you can help with dinner tonight. Every great chef needs a great assistant, and every task you do teaches you a new skill.'
  },
  {
    id: 1224,
    category: QuestCategory.SkillBuilder,
    title: 'The Baker\'s Apprentice',
    questlineId: 'chefs-journey',
    prerequisiteQuestId: 940,
    description: 'Time to learn a new discipline: baking. Follow a simple recipe to bake cookies or a cake.',
    details: 'Baking is a science! With an adult, find a simple recipe for cookies or a traybake. Your mission is to follow the instructions precisely. Measuring ingredients correctly is the key to success in baking. Enjoy your delicious experiment!',
    repeatDescription: 'Practice your baking skills with a new or favourite recipe.',
    repeatDetails: 'Time to get baking again! Follow a recipe carefully to create a delicious treat. Are you getting more confident with measuring and mixing?'
  },
  {
    id: 1225,
    category: QuestCategory.Creator,
    title: 'The Recipe Inventor',
    questlineId: 'chefs-journey',
    prerequisiteQuestId: 1224,
    description: 'You\'ve followed recipes, now it\'s time to create your own! Invent a recipe for a perfect sandwich or smoothie.',
    details: 'You are now an inventor! In your notebook, create a brand new recipe. It could be for the ultimate triple-decker sandwich or a cosmic super-smoothie. List the ingredients, write the step-by-step instructions, and give it an amazing name.'
  },
  {
    id: 1226,
    category: QuestCategory.TeamUp,
    title: 'Head Chef for a Day',
    questlineId: 'chefs-journey',
    prerequisiteQuestId: 1225,
    description: 'Your training has led to this. Your mission is to prepare one meal (like lunch) for the family.',
    details: 'Choose a meal you feel confident making (like the sandwich you invented or your pro-level lunch). With adult supervision, you are the Head Chef. You\'re in charge of preparing and serving the meal. Your family are the lucky customers!'
  }
];
